// Property Factory
import { formatDateTime } from "../utils/utils";

export const CustomerApiFactory = (customerData = {}) => {
    return {
      companyId: customerData.companyId || "",
      CompanyName: customerData.companyName || "",
      Address1: customerData.address1 || "",
      Address2: customerData.address2 || "",
      Address3: customerData.address3 || "",
      State: customerData.state || "",
      Country: customerData.country || "",
      City: customerData.city || "",
      PostCode: customerData.postCode || "",
      ADMINUser: customerData.adminUsername || "",
      AdminEmailAddress: customerData.adminEmailAddress || "",
      CompanyDomain: customerData.companyDomain || "",
      SubscriptionPlan: customerData.subscriptionPlan || "",
      SubscriptionRenew: formatDateTime(customerData.SubscriptionRenew, "%d/%m/%Y") || formatDateTime(customerData.subscriptionRenew, "%d/%m/%Y") || "",
      AI_Search_Enabled: customerData.aiSearch !== undefined ? customerData.aiSearch : false,
      URL: customerData.url || "",
      PrimaryColor: customerData.primaryColor || "",
      SecondaryColor: customerData.secondaryColor || "",
      TertiaryColor: customerData.tertiaryColor || "",
    };
  };